import { useEffect, useState } from "react";

const RELOAD_FLAG = "c8-admin-proxy-reload";

/** Dev-only: player SPA has no /admin bundle — reload so Parcel's /admin proxy can serve admin. */
export function AdminDevProxyReload() {
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === "production") return;

    const path = window.location.pathname;
    const adminUrl = path.endsWith("/") ? path : `${path}/`;

    if (sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.removeItem(RELOAD_FLAG);
      setShowHelp(true);
      return;
    }

    sessionStorage.setItem(RELOAD_FLAG, "1");
    window.location.assign(adminUrl);
  }, []);

  if (showHelp) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-main px-6 text-center font-chakra text-white">
        <h1 className="font-anton text-2xl uppercase">Admin dev server</h1>
        <p className="max-w-md text-white/70">
          Could not load the admin panel through the dev proxy. Start both apps from{" "}
          <code className="text-lime">frontend/</code>:
        </p>
        <pre className="rounded bg-mainB px-4 py-3 text-left text-sm text-white/90">yarn dev</pre>
        <p className="max-w-md text-sm text-white/55">
          Then open{" "}
          <a className="text-lime underline" href="http://localhost:1234/admin/">
            http://localhost:1234/admin/
          </a>{" "}
          (admin runs on :1235 and is proxied through :1234 for login cookies).
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-main font-chakra text-white/60">
      Loading admin…
    </div>
  );
}
